import {
  Dispatch,
  ReactNode,
  SetStateAction,
  createContext,
  useEffect,
  useState,
} from 'react'
import { useWindowSize } from 'usehooks-ts'
import { SanityColor } from '@data/sanity/queries/types/modules'

interface Size {
  width?: number
  height?: number
}

interface LayoutContextProps {
  windowSize: Size
  isHeaderTransparent: boolean
  headerBackgroundColor?: SanityColor
  setIsHeaderTransparent: Dispatch<SetStateAction<boolean>>
  setHeaderBackgroundColor: Dispatch<SetStateAction<SanityColor | undefined>>
}

interface LayoutContextProviderProps {
  pageIsHeaderTransparent: boolean
  pageHeaderBackgroundColor?: SanityColor
  children: ReactNode
}

export const LayoutContext = createContext<LayoutContextProps>({
  windowSize: {},
  isHeaderTransparent: false,
  setIsHeaderTransparent: () => {},
  setHeaderBackgroundColor: () => {},
})

export const LayoutContextProvider = ({
  pageIsHeaderTransparent,
  pageHeaderBackgroundColor,
  children,
}: LayoutContextProviderProps) => {
  const [isHeaderTransparent, setIsHeaderTransparent] = useState(
    pageIsHeaderTransparent,
  )
  const [headerBackgroundColor, setHeaderBackgroundColor] = useState(
    pageHeaderBackgroundColor,
  )

  const windowSize = useWindowSize()

  // Update page header when a new page is loaded
  useEffect(() => {
    if (pageIsHeaderTransparent !== isHeaderTransparent) {
      setIsHeaderTransparent(pageIsHeaderTransparent)
    }
  }, [isHeaderTransparent, pageIsHeaderTransparent])
  useEffect(() => {
    if (pageHeaderBackgroundColor !== headerBackgroundColor) {
      setHeaderBackgroundColor(pageHeaderBackgroundColor)
    }
  }, [headerBackgroundColor, pageHeaderBackgroundColor])

  return (
    <LayoutContext.Provider
      value={{
        windowSize,
        isHeaderTransparent,
        headerBackgroundColor,
        setIsHeaderTransparent,
        setHeaderBackgroundColor,
      }}
    >
      {children}
    </LayoutContext.Provider>
  )
}
